export default "__VITE_ASSET__CNF69W9Y__"